import React from 'react';
import { Card, CardContent } from './ui/card';
import { Mic, BookOpen, Users, Trophy } from 'lucide-react';
import { contributions } from '../data/mock';

const iconMap = {
  1: Mic,
  2: BookOpen,
  3: Trophy,
  4: Users
};

const Contributions = () => {
  return (
    <section id="contributions" className="py-20 bg-gradient-to-br from-slate-800 to-slate-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-amber-400 font-semibold text-lg mb-2">Leadership & Recognition</p>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            Professional Contributions
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Actively contributing to the professional community through leadership, education, and knowledge sharing
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {contributions.map((contribution) => {
            const IconComponent = iconMap[contribution.id];
            return (
              <Card
                key={contribution.id}
                className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border-none bg-white/5 backdrop-blur-sm hover:bg-white/10"
              >
                <CardContent className="pt-8">
                  <div className="flex items-start space-x-6">
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 bg-amber-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <IconComponent className="w-8 h-8 text-white" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-3">
                        <h3 className="text-2xl font-bold text-white">
                          {contribution.title}
                        </h3>
                        <span className="text-amber-400 font-semibold text-sm">
                          {contribution.year}
                        </span>
                      </div>
                      <p className="text-gray-300 leading-relaxed text-lg">
                        {contribution.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto border border-white/20">
            <p className="text-xl text-gray-200 leading-relaxed">
              Regular speaker at prestigious forums including ICAI seminars, corporate workshops, and industry 
              conferences. Specializing in practical GST interpretation, international tax structuring, and 
              emerging trends in tax litigation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contributions;